import { AxiosReqConfig } from '../utils/request';
import { END_POINTS, ProtectedRequest } from './helper';

const SotService = {
  generateShiftSync: (
    facilityCode: string,
    data: any = {},
    config: AxiosReqConfig = {}
  ) =>
    ProtectedRequest.post(END_POINTS.SOT.generateShiftSync, data, {
      ...config,
      params: { ...config.params, facility_code: facilityCode },
    }),
  generateShiftAsync: (facilityCode: string, data: any = {}) =>
    ProtectedRequest.post(END_POINTS.SOT.generateShiftAsync, data, {
      params: { facility_code: facilityCode },
    }),
  getAllForcedShifts: (facilityCode: string, clientId?: string) =>
    ProtectedRequest.get(END_POINTS.SOT.forcedShifts(facilityCode), {
      params: { client_id: clientId },
    }),
  updateForcedShifts: (
    facilityCode: string,
    data: ForcedShiftParam[] = [],
    clientId?: string
  ) =>
    ProtectedRequest.post(END_POINTS.SOT.forcedShifts(facilityCode), data, {
      params: { client_id: clientId },
    }),
  getInputParamVersions: (facilityCode: string) =>
    ProtectedRequest.get(END_POINTS.SOT.versions, {
      params: { facility_code: facilityCode },
    }),
  addNewVersion: (facilityCode: string, data: InputVersionParam[]) =>
    ProtectedRequest.post(END_POINTS.SOT.addNewVersion, data, {
      params: { facility: facilityCode },
    }),
  updateParamVersion: (facilityCode: string, data: UpdateInputParamVersion[]) =>
    ProtectedRequest.post(END_POINTS.SOT.updateParamVersion, data, {
      params: { facility: facilityCode },
    }),
  deleteParamVersion: (facilityCode: string, versionId: string) =>
    ProtectedRequest.delete(END_POINTS.SOT.deleteParamVersion, {
      params: { facility_code: facilityCode, version_id: versionId },
    }),
};

export default SotService;

export type ForcedShiftParam = {
  shift_start: string;
  provider_type: string;
  shift_length: number;
};
export interface InputVersionParam {
  // client_id: string;
  version_name?: string;
  facility_app_shift_length: number[];
  facility_physician_shift_length: number[];
  cube_start_date: string;
  cube_end_date: string;
  patient_volume: number;
  app_patients_per_hour: number;
  physician_patients_per_hour: number;
  shift_start_time: number;
  PctOfCases99281APPAuto: number;
  PctOfCases99282APPAuto: number;
  PctOfCases99283APPAuto: number;
  PctOfCases99284APPAuto: number;
  PctOfCases99285APPAuto: number;
  PctOfCases99291APPAuto: number;
  PctOfCases99281Shared: number;
  PctOfCases99282Shared: number;
  PctOfCases99283Shared: number;
  PctOfCases99284Shared: number;
  PctOfCases99285Shared: number;
  PctOfCases99291Shared: number;
  forced_shift_data: ForcedShiftParam[];
  patient_volume_flag: boolean;
  base_line_flag: boolean;
}
export interface UpdateInputParamVersion extends InputVersionParam {
  version_id: string;
}
